module.exports = __webpack_public_path__ + "img/skill-icon-1.3225c34b.png";